<av-menu-item
  [attr.aria-label]="'Send link to chat' | translate"
  icon="chat"
  (select)="shareLink()"
  data-tid="conference/send-to-chat"
>
  <span translate>Send to Chat</span>
</av-menu-item>
